import React from "react";
import { Star } from "lucide-react";

const TestimonialCard = ({ name, position, content, rating, image }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100">
      <div className="flex items-center space-x-1 mb-4">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            size={16}
            fill={i < rating ? "#eab308" : "none"}
            className={i < rating ? "text-psa-gold-400" : "text-gray-300"}
          />
        ))}
      </div>
      <p className="text-gray-600 mb-6 italic">{content}</p>
      <div className="flex items-center">
        <img
          src={image}
          alt={name}
          className="w-12 h-12 rounded-full object-cover mr-4"
        />
        <div>
          <h4 className="font-semibold text-gray-900">{name}</h4>
          <p className="text-sm text-gray-500">{position}</p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
